<div class="row">
	<div class="col-md-2"></div>
		<div class="col-md-8">
			<video width="100%" height="auto" controls autoplay>
			  <source src="/assets/videos/what_is_cbti.mp4" type="video/mp4">
			Your browser does not support the video tag.
			</video>
		</div>
	<div class="col-md-2"></div>

</div>